import { cloneElement } from "react";
import { NewConnectionProvider, useNewConnectionContext } from "../../context/NewConnectionContext";
import StepIndicator from "../../components/StepIndicator";
import { useWizardSteps } from "../../hooks/useWizardSteps";
import { ConnectionMapping } from "../../types";
import { WIZARD_STEP_COMPONENTS, WIZARD_TOTAL_STEPS, getWizardSkipIndices } from "./wizardConfig";

export interface StepProps {
  handleButtonBackClick?: (mappingsOverride?: ConnectionMapping[]) => void;
  handleButtonNextClick?: (mappingsOverride?: ConnectionMapping[]) => void;
  stepIndicator?: React.ReactNode;
  children?: React.ReactNode;
}

const AddNewConnectionWizard = () => {
  const { newConnectionData } = useNewConnectionContext();
  const skipIndices = getWizardSkipIndices(newConnectionData.mappings);
  const { currentStepIndex, highestVisitedIndex, goToStep, goBack, goNext } =
    useWizardSteps(WIZARD_STEP_COMPONENTS.length, skipIndices);

  const stepIndicator = (
    <StepIndicator
      totalSteps={WIZARD_TOTAL_STEPS}
      currentIndex={currentStepIndex}
      highestVisitedIndex={highestVisitedIndex}
      onStepClick={goToStep}
    />
  );

  const StepComponent = cloneElement(WIZARD_STEP_COMPONENTS[currentStepIndex], {
    handleButtonBackClick: goBack,
    handleButtonNextClick: goNext,
    stepIndicator,
  });

  return <div>{StepComponent}</div>;
};

const AddNewConnection = () => (
  <NewConnectionProvider>
    <AddNewConnectionWizard />
  </NewConnectionProvider>
);

export default AddNewConnection;
